import authorization from './authorization';
import cache from './cache';
import dnc from './endpoints/dnc/index';
import general from './endpoints/general';
import grouping from './endpoints/grouping';
import management from './endpoints/management';
import points from './endpoints/points';
import report from './endpoints/report';
import sales from './endpoints/sales';
import store from './endpoints/store';
import poi from './endpoints/pointOfInterest';
import summary from './endpoints/summary';
import themes from './endpoints/themes';
import upload from './endpoints/upload';
import fetch from './fetch';
import socket from './socket';
import { FuelStationStore } from './endpoints/fuelStation';
import afterSales from './endpoints/afterSales';
import shapes from './endpoints/shapes';
import greenfield from './endpoints/greenfield';
import newGreenfield from './endpoints/newGreenfield';
import brownfield from './endpoints/brownfield';

const api = (window.NeoAPI = {
    authorization,
    cache,
    dnc,
    fetch,
    fuelStation: FuelStationStore,
    general,
    grouping,
    management,
    points,
    report,
    sales,
    socket,
    store,
    poi,
    summary,
    themes,
    upload,
    afterSales,
    greenfield,
    newGreenfield,
    brownfield,
    shapes: shapes
});

export default api;



// WEBPACK FOOTER //
// ./src/scripts/api/index.js